<template>
  <div class="label-slt v1">
    <el-form size="mini">
      <el-form-item :label="labelText" :class="{'must': config.must}">
        <el-select
          :placeholder="placeholder"
          :popper-class="popperClass"
          :multiple="config.isMult"
          v-model="res"
          @visible-change="data => $emit('visible-change', data)">
          <div slot="empty" class="select_empty">
            <slot name="empty">无数据</slot>
          </div>
          <el-option v-for="item in list" :key="item.code" :value="item.code" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'PointSelect',
  props: {
    config: {
      type: Object,
      default () {
        // isMult?：是否多选
        // defaultValue?: 默任选择内容
        // placeholder?: 占位文案
        // must?: 是否必填项
        // popClass?: 自定义样式类
        return {}
      }
    },
    labelText: String,
    pList: Array, // [ { label: '', labelValue: '' } ]
    value: Array
  },
  data () {
    return {}
  },
  computed: {
    popperClass () {
      if (!this.config.popClass) return 'form_pop'
      return 'form_pop ' + this.config.popClass.split(',').map(el => el.trim()).join(' ')
    },
    list () {
      return this.pList
    },
    placeholder () {
      return this.config.placeholder || '请选择'
    },
    isMult () {
      return this.config.isMult
    },
    res: {
      get () {
        if (this.isMult) return this.value && this.value.length ? this.value : []
        else return this.value && this.value[0] ? this.value[0] : '' // 对外的都是数组，单选的时候需要取出来展示正确
      },
      set (v) {
        const arr = this.isMult ? v : [v] // 单选 多选 都统一对外暴露数组数据，单选的情况用[]包装下
        this.$emit('input', arr)
      }
    },
    defaultV () {
      let list = this.list
      if (list && list.length) {
        if (this.config.defaultValue) return this.config.defaultValue
        else return ''
      }
      return ''
    }
  },
  watch: {
    defaultV: {
      immediate: true,
      handler (v) {
        if (v) this.res = v
      }
    }
  }
}
</script>

<style lang="scss">
.form_pop {
  .select_empty {
    padding: 10px 0;
    margin: 0;
    text-align: center;
    color: #999;
    font-size: 14px;
  }
}
.my-sel-empty__data {
  color: #666;
  padding: 30px 0;
}
</style>
<style lang="sass" scoped>
.label-slt.v1
  margin-bottom: 20px
  border-radius: 4px
  background: #fff
  position: relative
  ::v-deep .el-form

    .el-form-item
      padding: 1px

      label
        font-weight: 600
        position: absolute
        left: 20px
        top: 50%
        margin-top: -10px
        z-index: 1
        padding-right: 10px
        border-right: 1px solid #e9e9e9

      .el-select
        width: 100%
        border: none
        .el-input
          width: 100%
          &.is-focus
            .el-input__inner
              border-color: #e9e9e9

        .el-input__suffix
          right: 10px

        input
          cursor: pointer
          font-size: 14px
          padding: 5px 0 5px 98px
          min-height: 38px

        .el-tag
          margin: 2px 2px 2px 0

        .el-select__tags
          padding-left: 100px
          .el-tag--info.el-tag--mini
            background-color: #f0f2f5
            border-color: transparent
            margin: 2px 2px 2px 0

          .el-tag__close.el-icon-close
            background-color: #c0c4cc
            right: -7px
            top: 0
            color: #fff
</style>
